/* UPGRADE MOTION (2.0). Vanilla, defer, no deps. Five jobs: scroll reveals
   ([data-ug-reveal], .ug-reveal), .ug-rise on injected cards, html.ug-scrolled /
   .ug-scroll-down for the header, <details> open/close, and window.UgMotion.
   Plus two clean-ups: photo fades that start off screen are finished at once (2b), skeleton
   pulses that are off screen are paused until they scroll in (2c).
   html.ug-js-motion gates the CSS and is set ONLY when motion is allowed (reduced
   motion off, not the theme editor): without it every page is fully visible. */
(function () {
  'use strict';
  if (window.UgMotion) return;
  var d = document.documentElement;
  var mq = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
  var CAP = 5;                                   // --i max: 6 steps
  var REVEAL = '[data-ug-reveal],.ug-reveal';
  var LCP = 'h1,img[fetchpriority="high"]';      // never hide an LCP candidate or its wrapper
  var WATCH = '[data-catalogue-grid],[data-ug-device-rail],[data-ug-pdp-related],[data-ug-rise-container]';
  // Our own accordions only. Scripts own the rest (details.ug-working, the finance drop, Dawn menus).
  var ACC = 'details.ug-faq__item,details.ug-accordion__item,details.ug-pdp__accordion,details[data-ug-accordion]';

  function reduced() { return !!(mq && mq.matches); }
  function still() { return reduced() || d.classList.contains('shopify-design-mode'); }
  function arr(x) { return !x ? [] : x.nodeType ? [x] : [].slice.call(x); }
  function all(sel, root) { return arr((root || document).querySelectorAll(sel)); }

  /* ---- 1 scroll reveals ---- */
  var io, fired, failsafe, waiting = [];
  function show(el, instant) {
    el.classList.add('is-in', 'is-revealed');      // is-in: core's .ug-reveal. is-revealed: ds's [data-ug-reveal]
    if (!instant) return;
    el.classList.add('is-instant');                // CSS: no animation / no transition
    if (el.classList.contains('ug-reveal')) setTimeout(function () { el.classList.remove('is-instant'); }, 150);  // a transition-based reveal must not stay off
  }
  function scan(list, live) {
    list = list.filter(function (el) { return !el.classList.contains('is-in'); });
    var vh = innerHeight, rows = new Map();
    var read = list.map(function (el) {            // all reads first
      var r = el.getBoundingClientRect(), m = rows.get(el.parentNode) || {}, t = Math.round(r.top / 4);
      rows.set(el.parentNode, m);
      m[t] = (m[t] || 0) + 1;                      // --i = place in its visual row
      // big: a plate over ~40% of the screen. The entrance would give it a layer as large as the plate to
      // raster mid-scroll; it shows at once instead, and its children can carry data-ug-reveal.
      return { el: el, i: Math.min(m[t] - 1, CAP), seen: !live && r.top < vh && r.bottom > 0, big: r.width * r.height > .4 * innerWidth * vh };
    });
    read.forEach(function (x) {
      var el = x.el;
      if (x.seen || x.big || !io || el.closest('h1') || el.matches(LCP) || el.querySelector(LCP)) return show(el, true);
      if (!el.classList.contains('ug-reveal')) el.setAttribute('data-ug-reveal', '');
      if (x.i) el.style.setProperty('--i', x.i);   // i = 0 (every block of a one-column page) writes nothing
      waiting.push(el);
      io.observe(el);
    });
  }
  function release(els) {
    els.forEach(function (el) { io.unobserve(el); show(el); });
    waiting = waiting.filter(function (el) { return els.indexOf(el) < 0; });
    els = els.filter(function (el) { return el.style.getPropertyValue('--i'); });
    if (els.length) setTimeout(function () {       // stagger is for the entrance only: hover is never late
      els.forEach(function (el) { el.style.removeProperty('--i'); });
    }, 900);
  }
  function onIO(entries) {
    fired = true;
    release(entries.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; }));
  }
  function revealAll() { if (io) io.disconnect(); waiting = []; all(REVEAL).forEach(function (el) { show(el, true); }); }

  /* ---- 2 injected cards ---- */
  var mo, dirty = [], queued;
  function watch(c) { if (mo && !c.__ugW) { c.__ugW = 1; mo.observe(c, { childList: true }); } }
  function mark(c) {
    if (dirty.indexOf(c) < 0) dirty.push(c);
    if (!queued) { queued = true; requestAnimationFrame(flush); }
  }
  function flush() {                               // before the new nodes are first painted
    var work = dirty; dirty = []; queued = false;
    if (still()) return;
    work.forEach(function (c) {
      var kids = arr(c.children).filter(function (n) { return !/skeleton/.test(n.className) && !n.matches(REVEAL); });
      var sig = kids.map(function (n) { var a = n.matches('a[href]') ? n : n.querySelector('a[href]'); return a ? a.getAttribute('href') : n.className; }).join('|');
      if (!kids.length) { c.__ugSig = ''; return; }    // emptied: the next set enters fresh
      if (sig === c.__ugSig) return;                   // same set repainted (prices arriving): no blink
      var again = !!c.__ugSig, k = 0, vh = innerHeight;
      c.__ugSig = sig;
      kids.filter(function (n) { var r = n.getBoundingClientRect(); return r.top < vh * 1.2 && r.bottom > 0; })
        .forEach(function (n) {
          if (!again && k) n.style.setProperty('--i', Math.min(k, CAP));   // a changed set settles together (no --i)
          k++;
          n.classList.toggle('ug-rise--again', again);
          n.classList.add('ug-rise');
        });
    });
  }
  document.addEventListener('animationend', function (e) {   // one-shot: never replays when re-shown
    var t = e.target;
    if (t.classList && t.classList.contains('ug-rise')) { t.classList.remove('ug-rise', 'ug-rise--again'); t.style.removeProperty('--i'); }
  });

  /* ---- 2b photo fades that nobody can see ----
     3.0 round (L-19, style cost). upgrade-motion.css section 03 fades every card and gallery photo in the moment it
     is first styled. The home rail holds ten cards and a phone shows two, the shop grid builds sixteen rows, the PDP
     strip keeps a slide per photo: the rest fade in off screen where no one can look, and every one of those fades
     restyles its card on each frame for 380ms (measured on the home page at 390px: 10 fades = ~1,200 of the ~3,400
     elements restyled during load; finishing the off-screen ones leaves ~450). Finishing an animation sets exactly
     the end state it was heading for, so nothing that is on screen changes; only the invisible work goes.
     Reads and writes are batched (every rect first, then every finish, once per frame, before that frame paints):
     finishing one and then measuring the next made each measurement a forced layout. */
  var photoQ = [], photoRaf = 0;
  function settlePhotos() {
    var q = photoQ, vh = innerHeight, vw = innerWidth;
    photoQ = []; photoRaf = 0;
    var off = q.map(function (a) {                 // reads
      var t = a.effect && a.effect.target, r = t && t.getBoundingClientRect();
      return !!r && (r.bottom <= 0 || r.top >= vh || r.right <= 0 || r.left >= vw);
    });
    q.forEach(function (a, i) {                    // writes
      if (off[i]) { try { a.finish(); } catch (e) { /* not finishable: leave it running */ } }
    });
  }
  function queuePhoto(a) {
    if (a.animationName !== 'ug-img-in') return;
    photoQ.push(a);
    if (!photoRaf) photoRaf = requestAnimationFrame(settlePhotos);
  }

  /* ---- 2c skeleton pulses nobody can see ----
     3.0 round (L-19). upgrade-ds.css pulses every skeleton plate (infinite, 640ms) while its list is still loading: ten
     on the home rail, twelve on the product page's related rail, eight in the shop grid, and a phone shows two or three.
     While the page is still busy loading, every pulsing plate is restyled on every frame (measured on the home page at
     390px with the catalogue answering after 1.2s: animation-driven restyles were 2,986 of 5,565 elements, 54%). An
     off-screen plate is paused and plays on again the moment it scrolls into view, so what is on screen is the same
     and the phase simply carries on. IntersectionObserver does the measuring: no layout read. */
  var pulseIO;
  function holdPulse(a) {
    var t = a.effect && a.effect.target;
    if (a.animationName !== 'ug-pulse' || !t || !window.IntersectionObserver) return;
    if (!pulseIO) pulseIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.target.isConnected) { pulseIO.unobserve(e.target); return; }   // the real cards replaced it
        e.target.getAnimations().forEach(function (x) {   // only ever changes a plate that is in the wrong state: one that is on screen is never touched
          if (x.animationName !== 'ug-pulse') return;
          if (e.isIntersecting) { if (x.playState === 'paused') x.play(); }
          else if (x.playState === 'running') x.pause();
        });
      });
    });
    pulseIO.observe(t);
  }
  function holdAnimation(a) { queuePhoto(a); holdPulse(a); }
  if (document.getAnimations) {
    document.addEventListener('animationstart', function (e) {
      if ((e.animationName !== 'ug-img-in' && e.animationName !== 'ug-pulse') || !e.target.getAnimations) return;
      e.target.getAnimations().forEach(holdAnimation);
    }, true);
  }

  /* ---- 3 header scroll state ---- */
  var hdr, ticking, scrolled = false, down = false, anchor = 0;
  function busy() {                                // lock, open menu, or KEYBOARD focus (a tapped button keeps :focus)
    if (!hdr || !hdr.isConnected) hdr = document.querySelector('.ug-header');
    var f = document.activeElement, kb = false;
    if (hdr && f && hdr.contains(f)) { try { kb = f.matches(':focus-visible'); } catch (e) { kb = true; } }
    return d.classList.contains('ug-lock') || kb || !!(hdr && hdr.querySelector('[aria-expanded="true"]'));
  }
  /* Repair (PA-2). The frame callback used to read d.scrollHeight on every frame while a reveal was still waiting,
     right after it had toggled html classes: a forced style + layout inside the callback (55-248ms at 4x CPU in
     the QA's long-animation-frame traces, 47-198ms of it forced). Now the callback does its one read first
     (the scroll offset), then only writes; the "end of the page" check, the only reader of the document height,
     runs once, after the scrolling has stopped, outside the frame. */
  var endTimer;
  function onScroll() {
    ticking = false;
    var y = Math.max(0, pageYOffset), want = down;       // reads first
    if (sbw < 0) measureBar();                     // locked when the page loaded: first scroll means it is not locked now
    if ((y > 8) !== scrolled) d.classList.toggle('ug-scrolled', scrolled = y > 8);
    if (still() || y <= 64 || busy()) { want = false; anchor = y; }
    else if (down) { if (y < anchor - 6) { want = false; anchor = y; } else if (y > anchor) anchor = y; }
    else if (y > anchor + 6) { want = true; anchor = y; }
    else if (y < anchor) anchor = y;               // 6px of hysteresis either way
    if (want !== down) d.classList.toggle('ug-scroll-down', down = want);
    if (waiting.length) { clearTimeout(endTimer); endTimer = setTimeout(atEnd, 120); }
  }
  // At the very end of the page nothing can climb above the -8% line: show what is on screen.
  function atEnd() {
    if (!waiting.length || innerHeight + Math.max(0, pageYOffset) < d.scrollHeight - 2) return;
    release(waiting.filter(function (el) { return el.getBoundingClientRect().top < innerHeight; }));   // every rect first, then the writes
  }
  function tick() { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }

  /* ---- 3b keyboard focus keeps a rail card whole (Repair, WCAG 2.4.7 / 2.4.11) ----
     The device rail and the related rail are scroll-snap scrollers. Tabbing to a card that was only partly in view
     left most of it off screen (about 85 of 280px shown at 390px): the browser counts a partly visible target as
     visible and does not scroll. scrollIntoView honours the rail's scroll-padding, scroll-snap and scroll-behavior
     (auto under reduced motion) and is a no-op for a card that is already whole. Keyboard focus only (:focus-visible),
     so a tap or a drag never moves the rail. Nothing physical is assumed: RTL scrolls the same way. */
  var RAIL = '[data-ug-device-rail],[data-ug-pdp-related]';
  function railKeep(t) {
    var rail = t && t.closest && t.closest(RAIL);
    if (!rail || !t.matches) return;
    try { if (!t.matches(':focus-visible')) return; } catch (e) { return; }
    (t.closest('.ug-card') || t).scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  /* ---- scrollbar width: html { --ug-sbw } (L-3) ----
     html.ug-lock hides the page scrollbar; the design system pads the page by this value so nothing
     jumps. Measured only while NOT locked: a lock removes the bar and the sum would read 0. */
  /* 3.0 round (L-19, style cost): a custom property written on <html> is inherited by every element, so each
     write restyles the whole document (measured: 641 of 787 elements). On a phone the scrollbar is an overlay
     and the width is 0; every consumer reads var(--ug-sbw, 0px), so "never written" already means 0px. The
     write is therefore skipped while the width is 0 and nothing has been written yet, and made once a real
     bar (desktop) is seen. sbw still records the measurement, so `sbw < 0` keeps meaning "not measured yet". */
  var sbw = -1, sbwSet = false, barFrame;
  function measureBar() {
    var body = document.body;
    if (d.matches('.ug-lock,.ug-catalogue-no-scroll,.ug-gal-open') || (body && body.classList.contains('overflow-hidden'))) return;
    var w = Math.max(0, Math.min(40, innerWidth - d.clientWidth));
    if (w === sbw) return;
    sbw = w;
    if (!w && !sbwSet) return;
    sbwSet = true;
    d.style.setProperty('--ug-sbw', w + 'px');
  }
  function remeasure() { cancelAnimationFrame(barFrame); barFrame = requestAnimationFrame(measureBar); }

  /* ---- 4 accordions ---- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || still() || !e.target.closest) return;
    var s = e.target.closest('summary'), det = s && s.parentNode, ctl = e.target.closest('a[href],button,input,select,textarea');
    if (!det || !det.matches || !det.matches(ACC) || det.querySelector('summary') !== s || (ctl && s.contains(ctl))) return;
    if (det._ugT) { e.preventDefault(); clearTimeout(det._ugT); det._ugT = 0; det.classList.remove('is-closing'); return; }  // press mid-close: stay open
    if (!det.open) { det.classList.add('is-opening'); return; }   // native open follows
    e.preventDefault();
    det.classList.replace('is-opening', 'is-closing') || det.classList.add('is-closing');
    det._ugT = setTimeout(function () { finish(det); }, 150);     // the timer, not animationend, decides the end state
  });
  function finish(det) {
    clearTimeout(det._ugT); det._ugT = 0;
    det.classList.remove('is-closing');
    det.removeAttribute('open');                   // fires the normal toggle event
  }
  document.addEventListener('toggle', function (e) {   // toggle does not bubble: capture
    var t = e.target;
    if (t.tagName === 'DETAILS' && !t.open) t.classList.remove('is-opening', 'is-closing');
  }, true);

  /* ---- wiring ---- */
  function sync() {
    if (still()) {
      d.classList.remove('ug-js-motion', 'ug-scroll-down');
      d.classList.add('ug-no-reveal');             // core's own "show everything" switch
      down = false;
      all('details.is-closing').forEach(finish);
      return revealAll();
    }
    if (d.hasAttribute('data-ug-fs')) {            // the failsafe in snippets/upgrade-head.liquid fired before this script arrived: undo it,
      d.removeAttribute('data-ug-fs');             // so scroll reveals work as they did when the failsafe was a CSS animation
      d.classList.remove('ug-no-reveal');
    }
    d.classList.add('ug-js-motion');
    if (!io && window.IntersectionObserver) io = new IntersectionObserver(onIO, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    scan(all(REVEAL), false);
    clearTimeout(failsafe);                        // observer never spoke: show everything
    failsafe = setTimeout(function () { if (!fired) revealAll(); }, 2500);
  }
  function init() {
    if (window.MutationObserver) mo = new MutationObserver(function (rs) { rs.forEach(function (r) { mark(r.target); }); });
    all(WATCH).forEach(watch);
    sync();
    if (document.getAnimations) document.getAnimations().forEach(holdAnimation);   // fades and pulses that started before this script ran
    onScroll();
    measureBar();
    addEventListener('resize', remeasure);
    addEventListener('load', remeasure);           // the page may only now be tall enough to have a bar
    addEventListener('scroll', tick, { passive: true });
    document.addEventListener('focusin', function (e) { if (down) tick(); railKeep(e.target); });
    if (mq) mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener && mq.addListener(sync);
  }

  window.UgMotion = {
    reveal: function (x) { if (still() || !io) arr(x).forEach(function (el) { show(el, true); }); else { scan(arr(x), true); tick(); } },
    rise: function (x) { if (!still()) arr(x).forEach(function (c) { watch(c); c.__ugSig = ''; mark(c); }); },
    prefersReduced: reduced,
    scrollState: function () { return { scrolled: scrolled, down: down }; }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
